<script lang="ts">
  import "$src/app.css";
  import "$src/error.css";
  import { page } from "$app/stores";
  import Error403 from "$lib/components/Errors/Error403.svelte";
</script>

<div
  class="flex flex-col justify-center place-items-center gap-28 text-black text-3xl"
>
  <img
    src="/logo.png"
    alt="laizee.ai Logo"
    class="m-auto w-1/6 min-w-80 mt-40 drag pointer-events-none"
  />
  {#if $page.status != 403}
    <div class="flex flex-col place-items-center">
      <div class="">Ein Fehler ist aufgetreten.</div>
      <div>{$page.status}: {$page.error?.message}</div>
    </div>
  {:else}
    <Error403 />
  {/if}
</div>

